var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.995,
    height: 23.974,
    viewBox: "0 0 23.995 23.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-link",
    "data-name": "Icon feather-link",
    transform: "translate(-1.993 -2.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M15,15.093a5.5,5.5,0,0,0,8.288.594l3.3-3.3a5.5,5.5,0,1,0-7.772-7.772L16.924,6.5",
    transform: "translate(-3.208 0)",
    fill: "none",
    stroke: "#3dc5d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M16.189,15.7A5.5,5.5,0,0,0,7.9,15.1L4.6,18.4a5.5,5.5,0,1,0,7.772,7.772l1.879-1.88",
    transform: "translate(0 -2.801)",
    fill: "none",
    stroke: "#3dc5d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.bebf495e0a25e6e71d34dcf5bdd8f1e3.svg";
export { ForwardRef as ReactComponent };